import React, { useContext, useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import SessionContext from '@providers/Session/SessionContext';
import useSwr from '@hooks/useSwr';

interface TransactionByStatusFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function TransactionByStatusField({
  options,
  loading,
  disabled = false,
}: TransactionByStatusFieldProps) {
  const { t } = useTranslation('create-alarm-step');
  const { customer } = useContext(SessionContext);
  const customerId = customer?.customerLogged?.id;
  const [selectedAppName, setSelectedAppName] = useState<string | undefined>();
  const form = Form.useFormInstance();

  const { data: statusData } = useSwr<{
    data?: string[];
  }>(
    customerId && selectedAppName
      ? `/service-proxy/dashboard/transacao/alarme/kapacitor/alerta_task/listar_transacao_status?appName=${selectedAppName}&customerId=${customerId}`
      : null,
    {
      headers: {
        customerId,
        appName: selectedAppName,
      },
    },
  );

  useEffect(() => {
    if (selectedAppName) {
      form.setFieldValue('transactionByStatusStatus', undefined);
    }
  }, [selectedAppName, form]);

  useEffect(() => {
    const formValue = form.getFieldValue('transactionByStatus');
    if (formValue && !selectedAppName) {
      setSelectedAppName(formValue);
    }
  }, [form, selectedAppName]);

  const statusOptions = Array.isArray(statusData)
    ? statusData.map(item => ({ label: item, value: item }))
    : (statusData?.data || []).map(item => ({ label: item, value: item }));

  return (
    <>
      <Form.Item
        name="transactionByStatus"
        label={t(
          'create-alarm-step:stepOne.createAlarmTransactionsByStatusField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepOne.createAlarmTransactionsByStatusRequired',
            ),
          },
        ]}
      >
        <Select
          allowClear
          options={options}
          loading={loading}
          disabled={loading || disabled}
          style={{ textAlign: 'left' }}
          onChange={value => {
            setSelectedAppName(value);
            form.setFieldValue('transactionByStatusStatus', undefined);
          }}
        />
      </Form.Item>

      {selectedAppName && (
        <Form.Item
          name="transactionByStatusStatus"
          label={t('create-alarm-step:stepOne.createAlarmStatusField')}
          rules={[
            {
              required: true,
              message: t(
                'create-alarm-step:stepOne.createAlarmStatusFieldRequired',
              ),
            },
          ]}
        >
          <Select
            allowClear
            options={statusOptions}
            loading={!statusData}
            disabled={!statusData}
            style={{ textAlign: 'left' }}
          />
        </Form.Item>
      )}
    </>
  );
}
